import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactNode } from 'react';

import Select from '../../../../../../components/select/select';
import { InputTooltip } from '../input-tooltip';

import './styles.scss';

interface IItemProperties {
  name: string;
  value: any;
  startIcon?: React.ReactNode;
}

interface ISubListProperties {
  name: string;
  key: any;
  startIcon?: React.ReactNode;
  items: (IItemProperties | ISubListProperties)[];
}

interface BacktestingSelectProps {
  values: (IItemProperties | ISubListProperties)[];
  defaultValue: IItemProperties | IItemProperties[];
  onChange: (value: any) => void;
  label?: string;
  tooltip?: ReactNode;
  errors?: string;
  customLabel?: ReactNode;
  disabled?: boolean;
  multiSelect?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'fluid';
  className?: string;
}

export const BacktestingSelect = ({
  size = 'sm',
  className = '',
  label,
  tooltip,
  errors,
  customLabel,
  ...props
}: BacktestingSelectProps) => {
  const hasErrors = !!errors?.length;
  const selectEl = (
    <Select
      className={`backtesting-form-select backtesting-select--${size} ${hasErrors ? 'backtesting-select--error' : ''} ${className}`.trim()}
      customLabel={customLabel}
      {...props}
    />
  );

  if (!label) {
    return selectEl;
  }

  return (
    <div className="backtesting-select-wrapper">
      <span className="backtesting-select-label">
        <span>{label}</span>
        {tooltip && <InputTooltip content={tooltip} />}
      </span>
      {selectEl}
      {hasErrors && (
        <div className="backtesting-select-error">
          <FontAwesomeIcon icon={faExclamationCircle} />
          {errors}
        </div>
      )}
    </div>
  );
};
